import { createSlice } from "@reduxjs/toolkit";
import { profileService } from "./profileService";
import { authService } from "../authentication/authService";

const initialState = {
  abilities: [],
  user: null,
  isLogin: true,
  isLoginCheck: false,
  invoice: {},
  openModal: false,
  paymentUrl: "",
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,

  reducers: {
    setUserLogout: (state) => {
      state.user = null;
      state.abilities = [];
    },

    setInvoice: (state, { payload }) => {
      state.invoice = payload;
    },

    setOpenModal: (state, { payload }) => {
      state.openModal = payload;
    },

    setPaymentUrl: (state, { payload }) => {
      state.paymentUrl = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      authService.endpoints.getUser.matchFulfilled,
      (state, { payload }) => {
        if (!payload.payload?.id) {
          return;
        }

        state.user = payload?.payload;
      },
    );

    builder.addMatcher(
      profileService.endpoints.createNewFund.matchFulfilled,
      (state, { payload }) => {
        state.openModal = false;
        state.user = {
          ...state.user,
          balance: payload?.data?.order?.balance,
        };
      },
    );

    builder.addMatcher(
      profileService.endpoints.createNewFund.matchRejected,
      (state, { payload }) => {
        state.openModal = false;
        state.user = {
          ...state.user,
          balance: payload?.data?.order?.balance,
        };
      },
    );
  },
});

export const { setUserLogout, setInvoice, setOpenModal, setPaymentUrl } =
  profileSlice.actions;

export const selectBillingModal = (state) => state.profile.openModal;
export const selectBillingUrl = (state) => state.profile.paymentUrl;

export default profileSlice.reducer;
